import Vue from 'vue'
import './plugins/firebase'
import App from './App.vue'
import router from './router' //routerの実行&ルート設定ファイル
import vuetify from './plugins/vuetify';

Vue.config.productionTip = false


new Vue({
  vuetify,
  router,//routerを追加
  render: h => h(App)
}).$mount('#app')
//https://qiita.com/FumioNonaka/items/4cf906826d8d472774b5を参照
